var app = 'achelos'



// WEBPACK FOOTER //
// src/assets/achelos.js